import { FormGroup,  AbstractControl, ValidatorFn} from '@angular/forms';
import * as moment from 'moment';
// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (!control.value) return null;
        if (!matchingControl.value) return null;
        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

export function DateValidator(startDate: string, endDate: string) {
    return (formGroup: FormGroup) => {
        const startDateControl = formGroup.controls[startDate];
        const endDateControl = formGroup.controls[endDate];
        if (!startDateControl.value) return null;
        if (!endDateControl.value) return null;


        // set error on control if validation fails
        var startD = moment(startDateControl.value, 'DD-MM-YYYY').utc().toDate();//Date format should be "DD-MM-YYYY"
        var endD = moment(endDateControl.value, 'DD-MM-YYYY').utc().toDate();
        if (moment(startD).isAfter(moment(endD))) {
            startDateControl.setErrors({ startDateError: true });
        } else {
            startDateControl.setErrors(null);
        }
    }
}
export function WithdrawDateValidator(startDate: string, endDate: string) {
    return (formGroup: FormGroup) => {
        const startDateControl = formGroup.controls[startDate];
        const endDateControl = formGroup.controls[endDate];
        if (!startDateControl.value) return null;
        if (!endDateControl.value) return null;


        // set error on control if validation fails
        var startD = moment(startDateControl.value, 'DD-MM-YYYY').utc().toDate();//Date format should be "DD-MM-YYYY"
        var endD = moment(endDateControl.value, 'DD-MM-YYYY').utc().toDate();
        if (moment(endD).isAfter(moment(startD))) {
            startDateControl.setErrors({ withdrawDateError: true });
        } else {
            startDateControl.setErrors(null);
        }
    }
}
export function formatNumber(value){
    if (value === null || value === undefined) {
     return '';
   }
   const num = Number(value.toString());
 return num % 1 === 0 ? num : Number(num.toFixed(2))
}

export function WithdrawDateValidator2(withdrawlDate: string, startDate: string, endDate: string) {
    return (formGroup: FormGroup) => {
        const startDateControl = formGroup.controls[startDate];
        const withdrawlDateControl = formGroup.controls[withdrawlDate];
        const endDateControl = formGroup.controls[endDate];
        if (!startDateControl.value) return null;
        if (!withdrawlDateControl.value) return null;
        if (!endDateControl.value) return null;


        // set error on control if validation fails
        var startD = moment(startDateControl.value, 'DD-MM-YYYY').utc().toDate();//Date format should be "DD-MM-YYYY"
        var withdrawlD = moment(withdrawlDateControl.value, 'DD-MM-YYYY').utc().toDate();
        var endD = moment(endDateControl.value, 'DD-MM-YYYY').utc().toDate();
        if (moment(withdrawlD).isSameOrBefore(startD) && moment(withdrawlD).isBefore(endD)) {
            //console.log("yes"); 
            withdrawlDateControl.setErrors(null);
        } else {
            //console.log("no");            
            withdrawlDateControl.setErrors({ startWithdrawDateError: true });
        }

        // else {
        //     startDateControl.setErrors(null);
        // }
    }
}

export function WithdrawDateValidator3(withdrawlDate: string, startDate: string, endDate: string) {
    return (formGroup: FormGroup) => {
        const startDateControl = formGroup.controls[startDate];
        const withdrawlDateControl = formGroup.controls[withdrawlDate];
        const endDateControl = formGroup.controls[endDate];
        if (!startDateControl.value) return null;
        if (!withdrawlDateControl.value) return null;
        if (!endDateControl.value) return null;


        // set error on control if validation fails
        var startD = moment(startDateControl.value, 'DD-MM-YYYY').utc().toDate();//Date format should be "DD-MM-YYYY"
        var withdrawlD = moment(withdrawlDateControl.value, 'DD-MM-YYYY').utc().toDate();
        var endD = moment(endDateControl.value, 'DD-MM-YYYY').utc().toDate();
        
        if (moment(withdrawlD).isAfter(startD) && moment(withdrawlD).isBefore(endD)) {
            //console.log("yes"); 
            startDateControl.setErrors(null);
        } else {
            //console.log("no");            
            withdrawlDateControl.setErrors({ drawDateError: true });
        }

        // else {
        //     startDateControl.setErrors(null);
        // }
    }
}

export function TimeValidator(startTime: string, endTime: string) {


    return (formGroup: FormGroup) => {
        const startTimeControl = formGroup.controls[startTime];
        const endTimeControl = formGroup.controls[endTime];
        if (!startTimeControl.value) return null;
        if (!endTimeControl.value) return null;
        var startTimeHoursM = moment(startTimeControl.value).format('HH:mm');
        var endTimeHoursM = moment(endTimeControl.value).format('HH:mm');
        // set error on control if validation fails
        if (endTimeHoursM <= startTimeHoursM) {
            startTimeControl.setErrors({ startTimeError: true });
        } else {
            startTimeControl.setErrors(null);
        }

    }
}


export function lettersWithOptionalSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;

        const regex = /^[A-Za-z]+(\s)?$/;

        if (value && !regex.test(value)) {
            return { 'invalidLettersWithSpace': true };
        }

        return null;
    };
}
